import { AutoComplete, AutoCompleteProps } from 'formik-antd';
import { AutoComplete as AntdAutoComplete } from 'antd';

import WithLoading from './WithLoading';

const FormikAutoCompleteWithLoadingHOC = WithLoading<AutoCompleteProps>(
  AutoComplete,
);

type FormikAutoCompleteWithLoadingType = typeof FormikAutoCompleteWithLoadingHOC;

interface IFormikAutoCompleteWithLoading
  extends FormikAutoCompleteWithLoadingType {
  Option: typeof AntdAutoComplete.Option;
}
const FormikAutoCompleteWithLoading = FormikAutoCompleteWithLoadingHOC as IFormikAutoCompleteWithLoading;

FormikAutoCompleteWithLoading.Option = AntdAutoComplete.Option;

export default FormikAutoCompleteWithLoading;
